import i18n from "@/i18n";

// 以当前语言推导 Intl 使用的区域标识（zh → zh-CN，en → en-US），
// 让日期、数字千分位、相对时间都随语言切换本地化。
function currentLocale(): string {
  const lng = i18n.language || "zh";
  return lng.toLowerCase().startsWith("en") ? "en-US" : "zh-CN";
}

export function formatNumber(value: number | null | undefined): string {
  if (value === null || value === undefined) return "--";
  return new Intl.NumberFormat(currentLocale()).format(value);
}

export function formatRelativeTime(input: string | Date): string {
  const date = typeof input === "string" ? new Date(input) : input;
  const diff = Date.now() - date.getTime();
  const minutes = Math.floor(diff / 60000);
  if (minutes < 1) return i18n.t("time.justNow");
  const rtf = new Intl.RelativeTimeFormat(currentLocale(), { numeric: "auto" });
  if (minutes < 60) return rtf.format(-minutes, "minute");
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return rtf.format(-hours, "hour");
  const days = Math.floor(hours / 24);
  if (days < 30) return rtf.format(-days, "day");
  return date.toLocaleDateString(currentLocale(), { year: "numeric", month: "2-digit", day: "2-digit" });
}

export function formatDate(input: string | Date): string {
  const date = typeof input === "string" ? new Date(input) : input;
  return date.toLocaleDateString(currentLocale(), { month: "2-digit", day: "2-digit" });
}

export function formatFullDate(input: string | Date): string {
  const date = typeof input === "string" ? new Date(input) : input;
  return date.toLocaleDateString(currentLocale(), { year: "numeric", month: "2-digit", day: "2-digit" });
}

export function formatDateTime(input: string | Date): string {
  const date = typeof input === "string" ? new Date(input) : input;
  return date.toLocaleString(currentLocale(), {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function daysUntil(input: string | Date): number {
  const date = typeof input === "string" ? new Date(input) : input;
  return Math.ceil((date.getTime() - Date.now()) / 86400000);
}

// 与后端续期逻辑保持一致：若当前到期时间在未来则在其基础上顺延，否则从今天起算。
export function addMonthsToDate(input: string | Date | null | undefined, months: number): Date {
  const now = new Date();
  const parsed = input ? (typeof input === "string" ? new Date(input) : new Date(input.getTime())) : now;
  const valid = !Number.isNaN(parsed.getTime());
  const base = valid && parsed.getTime() > now.getTime() ? parsed : new Date(now.getTime());
  base.setMonth(base.getMonth() + months);
  return base;
}

export function formatPercent(value: number | null | undefined): string {
  if (value === null || value === undefined) return "--";
  return `${Number(value).toFixed(2)}%`;
}